import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useState } from "react";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
type Props = {};

const FileAssigning = (props: Props) => {

  let navigate = useNavigate();







  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "5px",
          border: ".5px solid #FF7722",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
        MSSPL LIBRARY
          </Typography>

          <Grid item sm={4} xs={12}>
            {/* <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography> */}
          </Grid>
          <Divider />
          <br />
          <form >
            <Grid item xs={12} container spacing={2}>
{/* radio -RFID */}
            <Grid item lg={12} xs={12}>
            <FormGroup>
 <FormControlLabel required control={<Checkbox />} label="RFID EPC Stored at server" />
 </FormGroup>
           
    </Grid>
{/* radio -Antenna */}
    <Grid item lg={12} xs={12}>
    <FormControl>
 
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label" 
        name="row-radio-buttons-group"
      >
        <FormControlLabel value="Antenna-1" control={<Radio />} label="Antenna-1" />
        <FormControlLabel value="Antenna-2" control={<Radio />} label="Antenna-2" />
        <FormControlLabel value="Antenna-3" control={<Radio />} label="Antenna-3" />
        <FormControlLabel value="Antenna-4" control={<Radio />} label="Antenna-4" />
        <FormControlLabel value="Antenna-8" control={<Radio />} label="Antenna-8" />
      
     
      </RadioGroup>
    </FormControl>
    
    </Grid>

    {/*Epc   */}

    <Grid item lg={8} xs={12}>
                <TextField
               label={
                    <span>
                    Epc Number
                    </span>
                  }
                  placeholder="Epc Number"
                  size="small"
                  fullWidth
           />
         </Grid>

         <Grid item lg={2} sm={2} xs={2}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "8px",
                    }}
                  >
         Get epc
                  </Button>
                </Grid>
              </Grid>

{/* radio - Book */}
<Grid item lg={12} xs={12}>
    <FormControl>
 
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label" 
        name="row-radio-buttons-group"
      >
        <FormControlLabel value="Book" control={<Radio />} label="Book" />
        <FormControlLabel value="Member" control={<Radio />} label="Member" />
      
      
     
      </RadioGroup>
    </FormControl>
    
    </Grid>

        {/*Accession-No  */}
        <Grid item lg={8} xs={12}>
                <TextField
               label={
                    <span>
                   Accession-No
                    </span>
                  }
                  placeholder="Accession-No"
                  size="small"
                  fullWidth
           />
         </Grid>
         <Grid item lg={2} sm={2} xs={2}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "8px",
                    }}
                  >
  Assign Book
                  </Button>
                </Grid>
              </Grid>
                 {/*Book Title */}
        <Grid item lg={8} xs={12}>
                <TextField
               label={
                    <span>
                Book Title
                    </span>
                  }
                  placeholder="Book Title"
                  size="small"  fullWidth
                   />
         </Grid>
         <Grid item lg={2} sm={2} xs={2}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "8px",
                    }}
                  >
      Update Title
                  </Button>
                </Grid>
              </Grid>
                          {/*Location */}
        <Grid item lg={8} xs={12}>
                <TextField
               label={ <span> Location </span>}
               placeholder="Location"
                  size="small"   fullWidth
               
           />
         </Grid>

         <Grid item lg={3} sm={3} xs={3}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "8px",
                    }}
                  >
  Assign Location
                  </Button>
                </Grid>
              </Grid>

              {/* </Grid> */}

              {/*button  */}
              <Grid item xs={12} container spacing={2}  alignItems="center" justifyContent="center"  >
        <Grid item lg={1} sm={1} xs={1}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                    // marginLeft:"50px",
              
                  }}
                  // onClick={(e) => formik.resetForm()}
                >
              reset
                </Button>
              </Grid>

              <Grid item lg={2} sm={2} xs={2}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "10px",
                    }}
                  >
       EPC Delete
                  </Button>
                </Grid>
              </Grid>
              <Grid item lg={1} sm={1} xs={1}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "10px",
                    }}
                  >
          Print
                  </Button>
                </Grid>
              </Grid>

       </Grid>
{/* radio - Report */}
<Grid xs={12} sm={6} item>
                <FormControl
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                    // marginTop: "13px",
                  }}
                >
<Grid>
                    <FormLabel>Report Option</FormLabel>
                  </Grid>
                  <Grid>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                     
                   
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="PDF"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="Excel"
                      />
                    </RadioGroup>
                  </Grid>
                  </FormControl>
              </Grid>



</Grid>


    {/*  */}

          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default FileAssigning;